export const DETAILS_ROUTE_NAME = 'jobListingDetails';

export const JOB_LISTING_ROUTES = {
  get: '/job-listings/job-listings/by-employer/{employerId}',
  post: '/job-listings/job-listings',
  patch: '/job-listings/job-listings/{id}',
  delete: '/job-listings/job-listings/{id}',
};

export const JOB_LISTING_ACTIVE_ROUTES = {
  get: '/job-listings/active',
};

export const JOB_LISTING_MARKETPLACE_SEARCH_ROUTES = {
  get: '/job-listings/job-listings/marketplace-search',
};

export const JOB_LISTING_ACTIVATE_ROUTES = {
  post: '/job-listings/job-listings/{id}/activate',
};

export const JOB_LISTING_DEACTIVATE_ROUTES = {
  post: '/job-listings/job-listings/{id}/deactivate',
};

export const JOB_LISTING_FACILITIES_ROUTES = {
  put: '/job-listings/job-listings/{listingId}/facilities',
};

export const JOB_LISTING_STATES_ROUTES = {
  put: '/job-listings/job-listings/{listingId}/states',
};

export const JOB_LISTING_DETAILS_ROUTES = {
  post: '/job-listings/details',
  patch: '/job-listings/details/{id}',
};

export const JOB_LISTING_CALCULATIONS_ROUTES = {
  post: '/job-listings/details/calculations',
};

export const JOB_LISTING_SUMMARY_ROUTES = {
  post: '/job-listings/details/contract-summary',
};
